import { Nav } from "react-bootstrap";
import { BsSpeedometer2, BsPeople, BsInbox, BsGear } from "react-icons/bs";
import { MdAccountCircle } from "react-icons/md";
import { IoAccessibilityOutline } from "react-icons/io5";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { TbSeo } from "react-icons/tb";

const Sidebar = ({
  setOpenModule,
  openModule,
  setShowSidebar,
  showSidebar,
}) => {
  const menuItems = [
    { key: "dashboard", label: "Dashboard", icon: <BsSpeedometer2 /> },
    { key: "inbox", label: "Inbox", icon: <BsInbox /> },
    { key: "contacts", label: "Contacts", icon: <BsPeople /> },
    { key: "seo_management", label: "SEO", icon: <TbSeo /> },
    {
      key: "accessibility",
      label: "Accessibility",
      icon: <IoAccessibilityOutline />,
    },
    { key: "billings", label: "Billings", icon: <AiOutlineDollarCircle /> },
    { key: "settings", label: "Settings", icon: <BsGear /> },
  ];

  return (
    <aside
      className={`sidebar ${showSidebar ? "expanded" : "collapsed"}`}
      style={{ height: "calc(100vh - 57px)", display: "flex", flexDirection: "column" }}
    >
      <Nav className="flex-column p-2 gap-1 flex-grow-1">
        {menuItems.map((item) => {
          const isActive = openModule === item.key;

          return (
            <Nav.Link
              key={item.key}
              title={item.label}
              onClick={() => { setOpenModule(item.key); setShowSidebar(false) }}
              className={`sidebar-link ${isActive ? "active" : ""}`}
            >
              <span className="icon">{item.icon}</span>
              {showSidebar && <span className="label ms-2">{item.label}</span>}
            </Nav.Link>
          );
        })}
      </Nav>

      <div className="p-2">
        <Nav.Link
          title="Manage Account"
          onClick={() => setOpenModule("profileManagement")}
          className={`sidebar-link ${openModule === "profileManagement" ? "active" : ""}`}
        >
          <span className="icon">
            <MdAccountCircle style={{fontSize: 30}} />
          </span>
          {showSidebar && <span className="label ms-2">Account</span>}
        </Nav.Link>
      </div>
    </aside>
  );
};

export default Sidebar;
